import {
  CHANNEL_API_RESPONSE_SUCCESS,
  CHANNEL_API_RESPONSE_ERROR,
  UPDATE_CHANNEL_LOADING,
  RESET_CHANNEL_ERROR,
  GET_CHANNEL_BY_ID,
  GET_CHANNEL_BY_ACTIVE,
} from "./actionType";

// Common success
export const channelApiResponseSuccess = (response) => ({
  type: CHANNEL_API_RESPONSE_SUCCESS,
  payload: response,
});

// Common error
export const channelApiResponseError = (error) => ({
  type: CHANNEL_API_RESPONSE_ERROR,
  payload: error,
});

// Common loading
export const channelUpdateLoading = (isLoading) => ({
  type: UPDATE_CHANNEL_LOADING,
  payload: isLoading,
});

// common reset error
export const channelResetError = () => ({
  type: RESET_CHANNEL_ERROR,
});

export const getChannelById = (channelId) => ({
  type: GET_CHANNEL_BY_ID,
  payload: channelId,
});

export const getChannelByActive = () => ({
  type: GET_CHANNEL_BY_ACTIVE,
});
